/* Blackout Water — Product Page JS (minimal) */
document.addEventListener('DOMContentLoaded', () => {
  console.log('Blackout Water theme loaded');
});
